import { useState } from "react";
import { Dropdown } from "react-bootstrap";

// List of languages
const languages = [
  { name: "English", code: "en" },
  { name: "Chinese", code: "zh" },
];

export function LanguageDropdown({ value, translationIndex, onUpdate }) {

  const defaultIndex = languages.findIndex((l) => l.code == value);
  const defaultLanguage = defaultIndex == -1 ? null : languages[defaultIndex];
  const [currentLanguage, setCurrentLanguage] = useState(defaultLanguage);

  function onLanguageUpdate(index) {
    setCurrentLanguage(languages[index]);
    onUpdate(languages[index].code);
  }

  return (
    <Dropdown key={`translation.${translationIndex}.translation_dropdown_container`} drop="end">
      <Dropdown.Toggle variant="success" id="dropdown-basic">
        {currentLanguage == null ? "Language" : currentLanguage.name}
      </Dropdown.Toggle>
      <Dropdown.Menu>
        {
          languages.length > 0
            ? languages.map(function (item, index) {
              return <Dropdown.Item
                key={`translation.${translationIndex}.${index}_translation_drop_down_menu`}
                onClick={() => onLanguageUpdate(index)}
                name={item.code}>
                {item.name}
              </Dropdown.Item>;
            })
            : <></>
        }
      </Dropdown.Menu>
    </Dropdown>
  );
}